import { useState } from "react";
import { X } from "lucide-react";

export default function ChartModal({ open, onClose, children, title }) {
    if (!open) return null;

    return (
        <div
            data-testid="chart-modal-overlay"
            onClick={onClose}
            style={{
                position: "fixed",
                inset: 0,
                zIndex: 100,
                background: "rgba(0,0,0,0.85)",
                backdropFilter: "blur(8px)",
                WebkitBackdropFilter: "blur(8px)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: 24,
            }}
        >
            <div
                data-testid="chart-modal-content"
                onClick={(e) => e.stopPropagation()}
                style={{
                    width: "100%",
                    maxWidth: 1400,
                    maxHeight: "95vh",
                    overflowY: "auto",
                    background: "var(--pord-bg, #222518)",
                    borderRadius: 20,
                    border: "1px solid rgba(184,212,208,0.12)",
                    padding: "32px 28px",
                    position: "relative",
                }}
            >
                <button
                    data-testid="chart-modal-close"
                    onClick={onClose}
                    style={{
                        position: "absolute",
                        top: 16,
                        right: 16,
                        background: "none",
                        border: "1px solid rgba(184,212,208,0.18)",
                        borderRadius: 999,
                        width: 36,
                        height: 36,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        color: "var(--pord-sage, #9aada8)",
                        transition: "all 200ms ease",
                    }}
                >
                    <X size={16} />
                </button>
                {title && (
                    <div className="pord-eyebrow" style={{ marginBottom: 16 }}>
                        {title}
                    </div>
                )}
                {children}
            </div>
        </div>
    );
}
